import { app } from '../../../../../../app';
import { Controller } from './label-settings.controller';

app.component('companyUserLabelSettings', {
    bindings: {
        companyId: '<',
		labels: '<',
        labelGroup: '<',
		userLabelId:'<',
        numberOfUsers:'<'
    },
    controller: Controller,
    templateUrl: require('./label-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/label-settings/label-settings.component.js